module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('refresh', {
    staticClass: ["wxc-refresher"],
    attrs: {
      "display": _vm.refreshing ? 'show' : 'hide'
    },
    on: {
      "refresh": _vm.onRefresh,
      "pullingdown": _vm.onPullingDown
    }
  }, [(_vm.newStyleFlag) ? _c('div', {
    ref: "cycle",
    staticClass: ["cycle-container"]
  }, [_c('div', {
    ref: "cover1",
    staticClass: ["u-cover", "c1"]
  }, [_c('div', {
    staticClass: ["u-cover-cycle", "cover1"]
  })]), _c('div', {
    ref: "cover2",
    staticClass: ["u-cover", "c2"]
  }, [_c('div', {
    ref: "cover-cycle",
    staticClass: ["u-cover-cycle"]
  })])]) : _vm._e(), (_vm.newStyleFlag) ? _c('image', {
    ref: "arrow",
    staticClass: ["arrow-down"],
    attrs: {
      "src": _vm.ICON_ARROW_DOWN,
      "resize": "contain"
    }
  }) : _c('loading-indicator', {
    staticClass: ["indicator"]
  }), _c('text', {
    staticClass: ["u-txt"],
    style: {
      width: (_vm.textWidth + "px")
    }
  }, [_vm._v(_vm._s(_vm.refresherText))])])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-181b460c!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-refresher/index.vue
// module id = 207
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34